<etwin-main-layout>
  <ng-container *ngIf="user$ | async as user">
    <ng-container [ngSwitch]="user !== USER_NOT_FOUND ? user.type : USER_NOT_FOUND">

      <ng-container *ngSwitchCase="ObjectType.User">
        <section class="user-view">
          <article class="profile">
            <div class="avatar"><img src="assets/avatar.jpg"></div>
            <div class="name-banner">
              <h1>{{user.displayName.current.value}}</h1>
              <p class="title" i18n="Placeholder user title@@userprofile.title"><img src="assets/icons/dinoparc.png"> This is a very generic title</p>
            </div>
            <div class="profile-content">
              <div class="additional">
                <!-- <a class="btn primary" disabled>Add to my contacts</a> -->
                <a class="btn icon secondary" disabled><img src="assets/icons/mail.png"></a>
                <p class="alt-infos"><em>--</em> | <em>--</em> | <em>--</em></p>
              </div>
              <div class="clear"></div>
              <p class="bubble" i18n="Placeholder for user personal thoughts bubble@@userprofile.thoughts.bubble">« Personal thoughts are not available yet. This feature is still a placeholder at the moment and will be improved in the future. »</p>
            </div>
          </article>

          <div class="description" i18n="Placeholder for user personal description@@userprofile.description">
            <p>Personal descriptions are not available yet. This feature is still a placeholder at the moment and will be improved in the future.</p>
          </div>

          <div class="linked-users" *ngIf="user.links.twinoid.current !== null || user.links.hammerfestEs.current !== null || user.links.hammerfestFr.current !== null || user.links.hfestNet.current !== null || user.links.dinoparcCom.current !== null || user.links.enDinoparcCom.current !== null || user.links.spDinoparcCom.current !== null">
            <h4 i18n="Title of the user's linked profile archives, ie Twinoid id@@userprofile.linked">Linked archives</h4>
            <ng-container *ngIf="user.links.twinoid.current !== null">
              <etwin-linked-user [userId]="user.id" [link]="user.links.twinoid.current"></etwin-linked-user>
            </ng-container>
            <ng-container *ngIf="user.links.hammerfestEs.current !== null">
              <etwin-linked-user [userId]="user.id" [link]="user.links.hammerfestEs.current"></etwin-linked-user>
            </ng-container>
            <ng-container *ngIf="user.links.hammerfestFr.current !== null">
              <etwin-linked-user [userId]="user.id" [link]="user.links.hammerfestFr.current"></etwin-linked-user>
            </ng-container>
            <ng-container *ngIf="user.links.hfestNet.current !== null">
              <etwin-linked-user [userId]="user.id" [link]="user.links.hfestNet.current"></etwin-linked-user>
            </ng-container>
            <ng-container *ngIf="user.links.dinoparcCom.current !== null">
              <etwin-linked-user [userId]="user.id" [link]="user.links.dinoparcCom.current"></etwin-linked-user>
            </ng-container>
            <ng-container *ngIf="user.links.enDinoparcCom.current !== null">
              <etwin-linked-user [userId]="user.id" [link]="user.links.enDinoparcCom.current"></etwin-linked-user>
            </ng-container>
            <ng-container *ngIf="user.links.spDinoparcCom.current !== null">
              <etwin-linked-user [userId]="user.id" [link]="user.links.spDinoparcCom.current"></etwin-linked-user>
            </ng-container>
          </div>
        </section>

        <span class="actions" *ngIf="isAdministrator$ | async">
          <h2>Admin</h2>
          <a [href]="['', 'api', 'v1', 'users', user.id].join('/')">API</a>
        <h3>Profile</h3>
        <form
          method="POST"
          enctype="application/x-www-form-urlencoded"
          action="/actions/update-user-display-name"
          [formGroup]="displayNameForm"
          (ngSubmit)="onSubmitDisplayName($event)"
        >
          <input type="hidden" name="user_id" formControlName="userId" required="required" [value]="user.id"/>
          <label>
            <span i18n="New display name field label@@settings.displayName.label">New display name</span>
            <input type="text" name="display_name" class="field" formControlName="displayName" required="required"
                   [minlength]="$UserDisplayName.minLength" [maxlength]="$UserDisplayName.maxLength"
                   [pattern]="$UserDisplayName.pattern"/>
            <div *ngIf="displayName.invalid && (displayName.dirty || displayName.touched)" class="error">
              <div *ngIf="displayName.errors?.minlength" i18n="@@settings.displayName.minLength">
                The display name must be at least {{$UserDisplayName.minLength}} characters long.
              </div>
              <div *ngIf="displayName.errors?.maxlength" i18n="@@settings.displayName.maxLength">
                The display name must be at most {{$UserDisplayName.maxLength}} characters long.
              </div>
              <div *ngIf="displayName.errors?.pattern && !displayName.errors?.minlength"
                   i18n="@@settings.displayName.pattern">
                The display name can only use letters, spaces or parenthesis.
              </div>
            </div>
          </label>
          <input type="submit" class="btn primary" name="update_user_display_name"
                 [disabled]="displayNameForm.invalid || displayNameSubscription !== null"
                 i18n-value="@@settings.displayName.submit" value="Update display name"/>
          <div *ngIf="displayNameServerError" class="error" i18n="@@settings.displayName.unknownError">
            Update error: the display name is invalid or was changed too recently.
          </div>
        </form>
          <h3>Security</h3>
          <form
            method="POST"
            enctype="application/x-www-form-urlencoded"
            action="/actions/update-username"
            [formGroup]="usernameForm"
            (ngSubmit)="onSubmitUsername($event)"
          >
          <input type="hidden" name="user_id" formControlName="userId" required="required" [value]="user.id"/>
          <label>
            <span i18n="New username field label@@settings.username.label">Username</span>
            <input type="text" name="username" [ngClass]="{'field': true, 'empty': !user.username}"
                   formControlName="username" required="required"
                   [minlength]="$RawUsername.minLength" [maxlength]="$RawUsername.maxLength"
                   [pattern]="$RawUsername.pattern"/>
            <div *ngIf="username.invalid && (username.dirty || username.touched)" class="error">
              <div *ngIf="username.errors?.minlength" i18n="@@settings.username.minLength">
                The username must be at least {{$RawUsername.minLength}} characters long.
              </div>
              <div *ngIf="username.errors?.maxlength" i18n="@@settings.username.maxLength">
                The username must be at most {{$RawUsername.maxLength}} characters long.
              </div>
              <div *ngIf="username.errors?.pattern && !username.errors?.minlength" i18n="@@settings.username.pattern">
                The username can only use the lowercase english letters "a-z" and digits "0-9" (it must start with a
                letter).
              </div>
            </div>
          </label>
          <input type="submit" class="btn primary" name="update_username"
                 [disabled]="usernameForm.invalid || usernameSubscription !== null"
                 i18n-value="@@settings.username.submit" value="Update username"/>
          <div *ngIf="usernameServerError" class="error" i18n="@@settings.username.unknownError">
            Update error: the username is invalid, was changed too recently or is already used.
          </div>
        </form>

        <form
          method="POST"
          enctype="application/x-www-form-urlencoded"
          action="/actions/update-password"
          [formGroup]="passwordForm"
          (ngSubmit)="onSubmitPassword($event)"
        >
          <input type="hidden" name="user_id" formControlName="userId" required="required" [value]="user.id"/>
          <label>
            <span i18n="New password field label@@settings.password.label">New password</span>
            <input type="password" name="password" [ngClass]="{'field': true, 'empty': !user.hasPassword}" formControlName="password" required="required"
                   [minlength]="PASSWORD_LEN"/>
            <div *ngIf="password.invalid && (password.dirty || password.touched)" class="error">
              <div *ngIf="password.errors?.required" i18n="@@register.passwordRequired">
                The password is required.
              </div>
              <div *ngIf="password.errors?.minlength" i18n="@@register.passwordMinLength">
                The password must be at least {{PASSWORD_LEN}} characters long.
              </div>
            </div>
          </label>

          <input type="submit" class="btn primary" name="update_password" [disabled]="passwordForm.invalid || passwordSubscription !== null" i18n-value="@@settings.password.submit" value="Update password"/>
          <div *ngIf="passwordServerError" class="error" i18n="@@settings.password.unknownError">
            Update error: the password is invalid or was changed too recently (10 minutes).
          </div>
        </form>
          <h3>Links</h3>

        <form
          method="POST"
          enctype="application/x-www-form-urlencoded"
          action="/actions/update-tid"
          [formGroup]="tidForm"
          (ngSubmit)="onSubmitTid($event)"
        >
          <input type="hidden" name="user_id" formControlName="userId" required="required" [value]="user.id"/>
          <label>
            <span>Twinoid link</span>
            <input type="text" name="tid_id" class="field" formControlName="tidId" required="required"/>
          </label>

          <input type="submit" class="btn primary" name="update_tid" [disabled]="tidForm.invalid || tidSubscription !== null" value="Update Twinoid id"/>
          <div *ngIf="tidServerError" class="error">
            Update error.
          </div>
        </form>

        <form
          method="POST"
          enctype="application/x-www-form-urlencoded"
          action="/actions/update-hffr"
          [formGroup]="hfFrForm"
          (ngSubmit)="onSubmitHfFr($event)"
        >
          <input type="hidden" name="user_id" formControlName="userId" required="required" [value]="user.id"/>
          <label>
            <span>hammerfest.fr link</span>
            <input type="text" name="hfFr_id" class="field" formControlName="hfFrId" required="required"/>
          </label>

          <input type="submit" class="btn primary" name="update_hfFr" [disabled]="hfFrForm.invalid || hfFrSubscription !== null" value="Update hammerfest.fr id"/>
          <div *ngIf="hfFrServerError" class="error">
            Update error.
          </div>
        </form>

        <form
          method="POST"
          enctype="application/x-www-form-urlencoded"
          action="/actions/update-hffr"
          [formGroup]="hfEnForm"
          (ngSubmit)="onSubmitHfEn($event)"
        >
          <input type="hidden" name="user_id" formControlName="userId" required="required" [value]="user.id"/>
          <label>
            <span>hfest.net link</span>
            <input type="text" name="hfEn_id" class="field" formControlName="hfEnId" required="required"/>
          </label>

          <input type="submit" class="btn primary" name="update_hfEn" [disabled]="hfEnForm.invalid || hfEnSubscription !== null" value="Update hfest.net id"/>
          <div *ngIf="hfEnServerError" class="error">
            Update error.
          </div>
        </form>

        <form
          method="POST"
          enctype="application/x-www-form-urlencoded"
          action="/actions/update-hffr"
          [formGroup]="hfEsForm"
          (ngSubmit)="onSubmitHfEs($event)"
        >
          <input type="hidden" name="user_id" formControlName="userId" required="required" [value]="user.id"/>
          <label>
            <span>hammerfest.es link</span>
            <input type="text" name="hfEs_id" class="field" formControlName="hfEsId" required="required"/>
          </label>

          <input type="submit" class="btn primary" name="update_hfEs" [disabled]="hfEsForm.invalid || hfEsSubscription !== null" value="Update hammerfest.es id"/>
          <div *ngIf="hfEsServerError" class="error">
            Update error.
          </div>
        </form>
          <h3>Delete</h3>
          <etwin-delete-user-button [userId]="user.id"></etwin-delete-user-button>
      </span>
      </ng-container>

      <ng-container *ngSwitchDefault>
        <h1>User not found</h1>
      </ng-container>
    </ng-container>
  </ng-container>
</etwin-main-layout>
